import { createSelector } from 'reselect'
import { OrderedMap, List, is } from 'immutable'
import { isSameMonth, isSameYear, isSameMonthAndYear } from 'utils/momentUtils'
import _keys from 'lodash/keys'
import { runningStatuses } from './enum'
import moment from 'moment'


const getQueuesState = state => state.queues
export const getSiteQueues = state => getQueuesState(state).list
export const getCurrentQueue = state => getQueuesState(state).currentQueue
export const getQueuesActivePage = state => getQueuesState(state).pagination.activePage

export const getCurrentQueueStatuses = createSelector(
  getSiteQueues,
  getCurrentQueue,
  (queues, queueId) => queues.get(queueId) || new OrderedMap(),
)

export const getCurrentQueueStatus = createSelector(
  getCurrentQueueStatuses,
  statuses => statuses.size ? statuses.last() : undefined,
)

export const isSitemapParsed = createSelector(
  getCurrentQueueStatus,
  status => status !== undefined && ['STARTED', 'PARSING'].indexOf(status.status) === -1,
)

export const getQueuesPagination = createSelector(
  getSiteQueues,
  queues => {
    // pagination = { 2017: [3,4,8], 2018: [0] }
    return queues.reduce((pagination, queue) => {
      const timestamp = moment(queue.first().timestamp);
      const year = timestamp.year();
      const month = timestamp.month();

      if (!pagination[year]) {
        pagination[year] = [month];
      }
      else if (pagination[year].indexOf(month) === -1) {
        pagination[year].push(month)
        pagination[year].sort((a, b) => a - b);
      }

      return pagination
    }, {})
  },
)

export const getQueuesYears = createSelector(
  getQueuesPagination,
  pagination => {
    return _keys(pagination).map(key => parseInt(key, 10)).sort((a, b) => a - b);
  },
)

export const getQueuesMonths = createSelector(
  getQueuesPagination,
  getQueuesActivePage,
  getQueuesYears,
  (pagination, activePage, years) => {
    return pagination[activePage.year || years[years.length - 1]] || [];
  },
)

export const getPaginatedSiteQueues = createSelector(
  getSiteQueues,
  getQueuesActivePage,
  (list, activePage) => {
    const { month, year } = activePage;
    if (!list.size || !month && !year) {
      return list
    }

    return list.filter(queue => {
      const queueTimestamp = queue.first().timestamp;
      const currentStamp = moment(queueTimestamp);
      // Do not show in sidebar last queue if it's running.
      if (is(list.first(), queue) && runningStatuses.indexOf(queue.last().status) > -1) {
        return false
      }

      return currentStamp.year() === year && currentStamp.month() === month
    });
  },
)


export const getLastSiteQueueStatus = createSelector(
  getSiteQueues,
  queues => {
    const queue = queues.first()
    if (queue) {
      const queueId = queues.keySeq().first()
      const lastStatus = queue.last()
      return { ...lastStatus, queueId }
    }
  },
)



// WEBPACK FOOTER //
// ./src/modules/queues/selectors.js